import { observer } from 'mobx-react';
import React from 'react';
import 'swiper/swiper.scss';
import { SwiperSlide } from 'swiper/react';
import { sliderProps } from '../../../types/types';
import SliderWrapper from '../SliderWrapper';
import ContentBox from '../../ContentBox/ContentBox';
import { AppContext } from '../../../contexts/AppContext/AppContext';
import './ThumbnailPaginationSlider.scss';
import SNSCard from '../../SNSCard/SNSCard';

const ThumbnailPaginationSlider: React.FunctionComponent<sliderProps> =
    observer(
        ({
            slideData = [
                {
                    imgUrl: 'img/2021-02-03-3-49-54@2x.png',
                    name: '감자',
                    snsId: '@est_potato_line',
                    text: '#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면agg#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf #모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면agg#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf #모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면agg#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf #모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면agg#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf #모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면agg#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf ',
                    linkUrl: 'abc.com',
                },
                {
                    imgUrl: 'img/2021-02-03-3-49-54@2x.png',
                    name: '감자',
                    snsId: '@est_potato_line',
                    text: '#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면agg#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf',
                    linkUrl: 'abc.com',
                },
                {
                    imgUrl: 'img/2021-02-03-3-49-54@2x.png',
                    name: '감자',
                    snsId: '@est_potato_line',
                    text: '#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면agg#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf',
                    linkUrl: 'abc.com',
                },
                {
                    imgUrl: 'img/2021-02-03-3-49-54@2x.png',
                    name: '감자',
                    snsId: '@est_potato_line',
                    text: '#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면agg#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf',
                    linkUrl: 'abc.com',
                },
                {
                    imgUrl: 'img/2021-02-03-3-49-54@2x.png',
                    name: '감자',
                    snsId: '@est_potato_line',
                    text: '#모래찜질 #크어어시원~하다 #여름아돌아와#여름아돌아와 최대2 줄 넘어가면 asdfasdf',
                    linkUrl: 'abc.com',
                },
            ],
            ...props
        }) => {
            // console.log(slideData, 'social');
            return (
                <SliderWrapper
                    spaceBetween={16}
                    withThumbnailPagination={true}
                    objectsForThumbNailPagination={slideData}
                    {...props}
                >
                    {slideData.map((el, i) => {
                        return (
                            <SwiperSlide key={i}>
                                <SNSCard
                                    mediaUrl={el.mediaUrl}
                                    name={el.username}
                                    snsId={el.author}
                                    text={el.caption}
                                    linkUrl={el.permalink}
                                    mediaType={el.mediaType}
                                />
                            </SwiperSlide>
                        );
                    })}
                </SliderWrapper>
            );
        }
    );

export default ThumbnailPaginationSlider;
